<template>
  <div class>
    <v-card flat height="280" class="text-xs-justify subheading font-weight-light pa-2">
      <v-layout row wrap>
        <v-flex xs12 md2>
          <v-responsive class>
            <v-img max-width="400" max-height="300" contain :src="image2"></v-img>
          </v-responsive>
        </v-flex>
        <v-flex xs12 md7>
          <p
            class="display-2 text-xs-center pa-2 mt-5 pt-4 blue--text"
          >All human beings are born free and equal in dignity and rights.</p>
        </v-flex>
        <v-flex xs12 md3 class="mt-4 pt-3">
          <v-responsive class>
            <v-img max-width="400" max-height="300" contain :src="image"></v-img>
          </v-responsive>
          <v-layout right row wrap class="pa-1 mt-3"></v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider>
      <h4 class="text-xs-center pa-2 grey lighten-5 black--text">Protection Working Group</h4>
    </v-divider>
    <h1 class="text-xs-center pa-2 white">Protection Working Group</h1>
    <v-card flat id="events">
      <v-layout wrap row>
        <v-flex xs12 md12 class="white pa-2" v-for="event in events" :key="event.id">
          <v-card height="auto" dark color="white black--text pa-3" v-if="event.approved">
            <h4 class="grey lighten-3 blue--text pa-1">{{event.title}}</h4>
            <h4 class="grey lighten-4 pl-1 font-weight-light pt-1 pb-1 black--text">{{event.host}}</h4>
            <h4
              class="grey lighten-5 font-weight-light pl-1 pt-1 pb-1 red--text"
            >{{event.eventdate}}</h4>
            <span class="subheading font-weight-light pa-1">
              {{event.content}}
              <a :href="event.website" target="_blank">More details</a>
            </span>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider class="grey lighten-3"></v-divider>
    <v-card flat class="pa-4">
      <v-layout row wrap class="black--text">
        <v-flex xs12 md12>
          <h1
            class="pa-3 display-1 text-md-center grey--text"
          >"Peace can only last where human rights are respected, where the people are fed, and where individuals and nations are free."</h1>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider></v-divider>
    <h2
      class="text-md-center grey--text mt-3"
    >Open Source Platform for the Management and Cordination of Human Rights Events and Capacity Building Initiatives</h2>
    <v-divider class="grey lighten-2 mb-2"></v-divider>

    <v-layout wrap class="grey darken-3 grey--text pa-4">
      <v-flex xs12 sm3>
        <ul>
          <li>
            <h5>
              <a href="https://www.article19.org/" target="_blank">Article 19</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.amnesty.org/en/" target="_blank">Amnesty International</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.imlu.org/" target="_blank">Indepedent Medical Legal Unit(IMLU)</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://pbi-kenya.org/" target="_blank">Peace Brigades International</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.ogiek.org/" target="_blank">Ogiek People Development</a>
            </h5>
          </li>
        </ul>
      </v-flex>
      <v-flex xs12 sm3>
        <ul>
          <li>
            <h5>
              <a href="https://www.defenddefenders.org/" target="_blank">EHAHRDP (Defend Defenders)</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://pemakenya.org/" target="_blank">PEMA Kenya</a>
            </h5>
          </li>
          <li>
            <h5>
              <a
                href="https://www.knchr.org/"
                target="_blank"
              >Kenya National Commission on Human Rights</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.khrc.or.ke/" target="_blank">Kenya Human Rights Commission</a>
            </h5>
          </li>
          <li>
            <h5>
              <a
                href="https://www.galck.org/"
                target="_blank"
              >Gay and Lesbian Coalition of Kenya (GALCK)</a>
            </h5>
          </li>
        </ul>
      </v-flex>
      <v-flex xs12 sm3>
        <ul>
          <li>
            <h5>
              <a href="https://www.hrdcoalition.org/" target="_blank">National Coalition of HRDs</a>
            </h5>
          </li>
          <li>
            <h5>
              <a
                href="https://www.ijm.org/kenya"
                target="_blank"
              >International justice Mission (IJM)</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.hrw.org/" target="_blank">Human Rights Watch</a>
            </h5>
          </li>
          <li>
            <h5>Shield for Justice</h5>
          </li>
          <li>
            <h5>
              <a href="http://www.uhai-eashri.org/" target="_blank">UHAI-EASHRI</a>
            </h5>
          </li>
        </ul>
      </v-flex>
      <v-flex xs12 sm3>
        <ul>
          <li>
            <h5>
              <a
                href="https://www.protectioninternational.org/en/where/Kenya"
                target="_blank"
              >Protection International</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://kenya.actionaid.org/" target="_blank">ActionAID Kenya</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.ajws.org/" target="_blank">American Jewish World Service</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="https://www.uaf-africa.org/" target="_blank">Urgent Action Fund Africa</a>
            </h5>
          </li>
          <li>
            <h5>
              <a href="http://kituochasheria.or.ke/" target="_blank">Kituo cha Sheria</a>
            </h5>
          </li>
        </ul>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { db, auth, functions } from "@/fb";
import router from "../router.js";

export default {
  data() {
    return {
      image: require("../assets/123456.png"),
      image2: require("../assets/12345.png"),

      team: [],
      events: [],
      edate: "",
      etitle: "",
      econtent: "",
      ehost: ""
    };
  },
  created() {
    if (auth.currentUser != null) {
      this.$router.push({ name: "dashboard" });
      /*  db.collection("members").onSnapshot(res => {
        const changes = res.docChanges();
        changes.forEach(change => {
          if (change.type === "added") {
            this.team.push({
              ...change.doc.data(),
              id: change.doc.id
            });
          }
        });
      }); */
    }
    db.collection("events").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.events.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  }
};
</script>
<style>
li a {
  text-decoration: none;
  color: grey;
}
a {
  text-decoration: none;
}
</style>
